import instance from '../config/axios';
import { Endpoints } from './endPoints';

export const getGuestProductFormulation = async () => {
  try {
    const result = await instance({
      url: Endpoints.GET_GUEST_PRODUCT_FORMULATION,
      method: 'GET',
    });

    return result?.data;
  } catch (error) {
    console.error('Error fetching guest product formulations:', error);
    return null;
  }
};
